var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 2V4.26667C9.99984 4.64004 9.99984 4.82672 10.0725 4.96933C10.1364 5.09477 10.2384 5.19676 10.3638 5.26067C10.5064 5.33333 10.6931 5.33333 11.0665 5.33333H13.3332M6.6665 5.33333H3.99984C3.26346 5.33333 2.6665 5.93029 2.6665 6.66667V12.6667C2.6665 13.403 3.26346 14 3.99984 14H7.99984C8.73622 14 9.33317 13.403 9.33317 12.6667V10.6667M10.6665 2H8.79984C8.0531 2 7.67973 2 7.39452 2.14532C7.14363 2.27316 6.93966 2.47713 6.81183 2.72801C6.6665 3.01323 6.6665 3.3866 6.6665 4.13333V8.53333C6.6665 9.28007 6.6665 9.65344 6.81183 9.93865C6.93966 10.1895 7.14363 10.3935 7.39452 10.5213C7.67973 10.6667 8.0531 10.6667 8.79984 10.6667H11.1998C11.9466 10.6667 12.3199 10.6667 12.6052 10.5213C12.856 10.3935 13.06 10.1895 13.1878 9.93865C13.3332 9.65344 13.3332 9.28007 13.3332 8.53333V4.66667L10.6665 2Z",
    stroke: "#75CAC2",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.131f6eddee6c14f06bea0d18184f6ab1.svg";
export { ForwardRef as ReactComponent };